import React, { FunctionComponent } from "react";
import { styled, Block, IBlockProps } from "../../../seenspire-library";
import TooltipBase from "react-simple-tooltip";

const TooltipContent = styled(Block)`
  text-transform: "none";
  min-width: 200px;
  background-color: "#3A414B";
  border-radius: 5px;
  padding: 10px;
  line-height: 18px;
`;

const Tooltip: FunctionComponent<IBlockProps & { content: any; icon: any, placement?: any }> = ({
  content,
  icon,
  ...props
}) => {
  return (
    <TooltipBase
      {...props}
      padding={0}
      radius={5}
      background="#3A414B"
      border="#3A414B"
      fadeDuration={250}
      arrow={12}
      content={<TooltipContent {...props}>{content}</TooltipContent>}
    >
      {icon}
    </TooltipBase>
  );
};

export default Tooltip;
